define('gameday-index-enums/enums/events/DisplayEvents',{
	audioFeedSelected: "GameDayIndex::audioFeedSelected",
	showLogoutButton: "GameDayIndex::showLogoutButton"
});
